export { ICustomerDisplayService } from './ICustomerDisplayService';
export { ICustomerDisplayDevice } from './ICustomerDisplayDevice';
